import React from "react";
import "../styling/projects.css";
import SnookerImage from "./../images/AutomatedSnookerCounterImage.png";
import KochImage from "./../images/KochImage.gif";
import JLogo from "./../images/JLogo.jpg";

function Projects() {
  return (
    <div className="container-projects">
      <div className="wrapper">
        <div className="title-projects">
          <h2>Projects</h2>
        </div>
        <div className="projects-content">
          <a href="https://youtu.be/CLd6Z4GlJ8s" target="_blank">
            <div className="projects-entry">
              <div className="projects-image">
                <img src={SnookerImage}></img>
              </div>
              <div className="projects-data">
                <div className="projects-data-title">
                  <p>Automated Snooker Counter</p>
                </div>
                <div className="projects-data-description">
                  <p>
                    Snooker is a cue sport which involves players scoring points
                    by potting balls in a specific order on a
                    green-cloth-covered rectangular table. Due to its unique
                    scoring system, snooker matches require players to multitask
                    between gameplay and scorekeeping, thereby causing focus
                    disruptions in a sport requiring high concentration.
                  </p>
                  <p>
                    The current system uses a live video stream from an overhead
                    camera view of the table, which is then processed using
                    computer vision to calculate scores. To broaden the
                    applicability of this system, I utilized Ultralytics YOLO
                    real time object detection model to track the balls from a
                    front camera view instead. This removes the prerequisite of
                    the overhead camera which provides the unobstructed view of
                    the table and balls, allowing anyone with a tripod and
                    smartphone camera to employ the system, thereby vastly
                    increasing its applicability.
                  </p>
                </div>
              </div>
            </div>
          </a>
          <div className="projects-entry">
            <div className="projects-image">
              <img src={JLogo}></img>
            </div>
            <div className="projects-data">
              <div className="projects-data-title">
                <p>
                  Distributed Streaming Pipeline and Distributed File System
                </p>
              </div>
              <div className="projects-data-description">
                <p>
                  As part of the CS 425: Distributed Systems coursework, I
                  implemented a custom Distributed Streaming Pipeline coupled
                  with its own custom Distributed File System in GoLang, running
                  on 10 VMs with a fault tolerance of 2 machines at a time. The
                  Distributed Streaming Pipeline consists of 3 stages with 3
                  jobs for each stage, having a dedicated coordinator to
                  schedule jobs on machines with the initial and final stage
                  reading from and writing to the Distributed File System.
                </p>
                <p>
                  Joins, Leaves and Failures were monitored using an appointed
                  introducer and gossip style pinging. The Distributed File
                  System was implemented with consistent hashing on a ring
                  structure, having replicas in 2 successors. On failure, the
                  immediate successor detects the failure, the ownership is
                  taken over, and the file is rereplicated. The coordinator also
                  keeps track of updates to the membership list and reschedules
                  jobs onto alive machines.
                </p>
              </div>
            </div>
          </div>
          <div className="projects-entry">
            <div className="projects-image">
              <img src={JLogo}></img>
            </div>
            <div className="projects-data">
              <div className="projects-data-title">
                <p>Full Stack Gym Application</p>
              </div>
              <div className="projects-data-description">
                <p>
                  In a 4 member team, we implemented a full stack gym
                  application with the goal of allowing users to discover,
                  share, like and save workout routines to save gym enthusiasts
                  the headache of finding routines daily. The frontend was
                  implemented in React, with a Flask backend and SQLite
                  database.
                </p>
              </div>
            </div>
          </div>
          <div className="projects-entry">
            <div className="projects-image">
              <img src={KochImage}></img>
            </div>
            <div className="projects-data">
              <div className="projects-data-title">
                <p>Online Learning Website with the IML at UIUC</p>
              </div>
              <div className="projects-data-description">
                <p>
                  As part of a 3 member team, I developed the frontend of an
                  interactive online course targeted towards high school
                  students, with the aim of raising awareness on uncommon topics
                  in mathematics, in this case, Fractal Geometry.
                </p>
                <p>
                  In collaboration with my groupmates, we formulated a brief
                  curriculum on Fractal Geometry. Combined with functionalities
                  such as interactive activities, visualizations and quizzes,
                  the online learning platform aimed to overcome the limitations
                  set by the COVID-19 pandemic.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Projects;
